/**
 * Profil « PDA stock » : l'appareil ne sert qu'au stock. Toute autre page (caisse, paiement,
 * TPE, rapports, réglages…) renvoie au Mode Stock. Règles pures, testées.
 */
export const PDA_HOME = '/mode-stock';

/** Pages du stock gardées sur le PDA. */
const ALLOWED = new Set(['/mode-stock', '/mouvements', '/etiquettes']);

/** Anciennes pages de stock remplacées par une vue du Mode Stock, adaptée au PDA. */
const REPLACED: Record<string, string> = {
  '/inventaire': '/mode-stock?vue=stocks',
  '/inventaires': '/mode-stock?vue=inventaire',
  '/produits': '/mode-stock?vue=stocks',
};

/** Réglage des appareils : seul un responsable peut rendre l'appareil à la caisse. */
export const PDA_DEVICES_SETTINGS = '/config/appareils';

const trimSlash = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

/** Adresse où renvoyer le PDA, ou null si la page lui est permise. */
export const pdaRedirectFor = (pathname: string, canManageDevices: boolean): string | null => {
  const path = trimSlash(pathname);
  if (ALLOWED.has(path)) return null;
  if (path === PDA_DEVICES_SETTINGS && canManageDevices) return null;
  return REPLACED[path] ?? PDA_HOME;
};

export const canManageDevices = (role: string | null | undefined): boolean =>
  role === 'admin' || role === 'manager' || role === 'super_admin';
